import { useQuery } from '@tanstack/react-query';
import { membersApi, MemberDetailsResponse } from '@/api/members.api';

export const useMemberDetailsQuery = (memberId: string) => {
  return useQuery({
    queryKey: ['member', memberId],
    queryFn: () => membersApi.getMember({ memberId }),
    enabled: !!memberId,    
    gcTime: 15 * 1000, // 15 seconds - keep in cache for back/forth navigation
    refetchOnMount: true, // Always fetch fresh data when mounting (page load)
    refetchOnWindowFocus: false, // Don't refetch on window focus to avoid excessive calls
  });
};

// Export types for consistency
export type { MemberDetailsResponse }; 